import request from 'superagent';
import React from 'react';
import createReactClass from 'create-react-class';
import ReactDOM from 'react-dom';
import Keyer from '../keyer';
import Input from '../input';
import View from '../view';
import events from '../../events';

let defaults = {
	el: null,
	inputSelector: 'input',
	resultsSelector: '.slx-datalist__wrap',
	letterLimit: 1,
	action: null,
	component: null
};

export default class Datalist extends View {
	constructor(options) {
		super(options, defaults);
		this.inputEl = this.el.query(this.params.inputSelector);
		this.resultsEl = this.el.query(this.params.resultsSelector);
		const form = this.el.query('form') || this.el;
		this.action = form.getAttribute('data-ajax') || form.getAttribute('action');

		this.keyer = new Keyer({
			target: this.el,
			keyEvent: 'keyup'
		});

		this.input = new Input({
			el: this.inputEl
		});
	}

	start() {
		super.start();
		this.input.start();
		this.keyer.start();

		// Debug IE, input with placeholder fire input event on load
		setTimeout(() => {
			this.input.events.on('change', this.onInputChange.bind(this));
		}, 500);
	}

	initEvents() {
		super.initEvents();
		this.keyer.on('up', this.onUpDown.bind(this));
		this.keyer.on('down', this.onDownDown.bind(this));
		this.keyer.on('enter', this.onEnterDown.bind(this));
		this.el.addEventListener('layoutOpen', this.onLayoutOpen.bind(this));
		this.el.addEventListener('layoutClose', this.onLayoutClose.bind(this));
	}

	onInputChange() {
		const text = this.input.getValue();
		const isEmpty = text ? text.length < this.params.letterLimit : false;
		this.getData(text, this.render.bind(this), isEmpty);
		this.lastSearch = this.input.getValue();
		if (!container.classList.contains('active')) {
			this.openLayout();
		}
		this.events.emit('input-change', this.lastSearch);
	}

	openLayout() {
		if (this.el.classList.contains('active')) {
			return;
		}
		events.emit('openLayout', this.el);
	}

	onLayoutOpen() {
		this.events.emit('openLayout');
	}

	onLayoutClose() {
		this.events.emit('closeLayout');
	}

	getData(query, done, isEmpty = false) {
		if (isEmpty) {
			return done();
		}
		this.el.classList.add('loading');
		if (this.req) {
			this.req.abort();
		}
		let data = {ajax: true};
		data[this.input.getName()] = query;
		this.req = request
			.get(this.action)
			.query(data)
			.end((err, res) => {
				if (res.status !== 200) {
					throw new Error('status != 200');
				}
				if (err) {
					throw new Error(err);
				}
				this.data = res.body;
				this.el.classList.remove('loading');
				this.req = null;
				done();
			});
	}


	onUpDown(e) {
		if (this.comp) {
			this.comp.activateItem('previous');
		}
	}

	onDownDown(e) {
		if (this.comp) {
			this.comp.activateItem('next');
		}
	}

	onEnterDown() {
		if (this.comp) {
			this.comp.goItem();
		}
	}

	focus() {
		this.input.focus();
	}

	setValue(value) {
		this.input.setValue(value);
	}

	getValue() {
		return this.input.getValue();
	}

	getLastSearch() {
		return this.lastSearch;
	}

	render() {
		this.comp = ReactDOM.render(<this.params.component data={this.data}/>, this.resultsEl);
	}
}
